export default {
  // Options.jsx
  items_per_page: '/ leheküljel',
  label_items_per_page: 'Items / page',
  jump_to: 'Hüppa',
  jump_to_confirm: 'Kinnitage',
  page: '',

  // Pagination.jsx
  first_page: 'First Page',
  last_page: 'Last Page',
  prev_page: 'Eelmine leht',
  next_page: 'Järgmine leht',
  prev_5: 'Eelmised 5 lehekülge',
  next_5: 'Järgmised 5 lehekülge',
  prev_3: 'Eelmised 3 lehekülge',
  next_3: 'Järgmised 3 lehekülge',
};
